import React from 'react';
import { emojis } from './consts';
export const Emoji = ({ shortcode }) => {
    const { name, html } = emojis[shortcode];
    return React.createElement("span", { dangerouslySetInnerHTML: { __html: html }, role: "img", "aria-label": `${name} emoji` });
};
